import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0da9412a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "season-detail-wrapper" }
const _hoisted_2 = { class: "layout-inner -wide -top-and-bottom" }
const _hoisted_3 = { class: "season-detail-content" }
const _hoisted_4 = { class: "main-block" }
const _hoisted_5 = {
  key: 0,
  class: "game-block _pcTabDisp"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "season-heading" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "circle" }),
  /*#__PURE__*/_createTextVNode("今日の試合")
], -1))
const _hoisted_7 = { class: "vs-list" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "vs" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "vsText" }, "VS")
], -1))
const _hoisted_9 = { class: "teams" }
const _hoisted_10 = { class: "team-block" }
const _hoisted_11 = { class: "name" }
const _hoisted_12 = { class: "division" }
const _hoisted_13 = { class: "team-block" }
const _hoisted_14 = { class: "name" }
const _hoisted_15 = { class: "division" }
const _hoisted_16 = { class: "group-block" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "group-block-header" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "season-heading" }, "グループ一覧")
], -1))
const _hoisted_18 = {
  key: 0,
  class: "group-table"
}
const _hoisted_19 = { class: "tbody" }
const _hoisted_20 = {
  class: "group-table-th",
  width: "156"
}
const _hoisted_21 = {
  class: "group-table-td",
  width: "80"
}
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" 全試合 ")
const _hoisted_23 = { class: "group-table-td" }
const _hoisted_24 = {
  key: 1,
  class: "empty-block"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "attention" }, [
  /*#__PURE__*/_createTextVNode("作成されたグループ構成が"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("ここに表示されます")
], -1))
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = { class: "global-loading" }
const _hoisted_28 = { class: "side-block _pcTabDisp" }
const _hoisted_29 = { class: "entry-team-block" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "season-heading" }, "エントリーチーム", -1))
const _hoisted_31 = {
  key: 0,
  class: "entry-team-list"
}
const _hoisted_32 = { class: "division" }
const _hoisted_33 = {
  key: 1,
  class: "empty-block"
}
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "attention" }, [
  /*#__PURE__*/_createTextVNode("登録されたエントリーチームが"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("ここに表示されます")
], -1))
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = { class: "global-loading" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseBreadcrumb = _resolveComponent("BaseBreadcrumb")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_BaseBreadcrumb, {
      breadcrumbs: _ctx.breadcrumbs,
      onOnChangeInput: _ctx.updateSeason
    }, null, 8, ["breadcrumbs", "onOnChangeInput"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.season.todays?.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("ul", _hoisted_7, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.season.todays, (game) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: game.id,
                      class: "item"
                    }, [
                      _createVNode(_component_router_link, {
                        to: {
                    name: 'seasonGameDetail',
                    params: { topic_id: _ctx.$route.params.topic_id, season_id: _ctx.$route.params.season_id, game_id: game.id },
                    query: { group: game.group_id } },
                        class: "vs-card"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_8,
                          _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("div", _hoisted_10, [
                              _createElementVNode("p", _hoisted_11, [
                                _createTextVNode(_toDisplayString(game.home.team_short_name), 1),
                                _createElementVNode("span", _hoisted_12, _toDisplayString(game.home.division), 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_13, [
                              _createElementVNode("p", _hoisted_14, [
                                _createTextVNode(_toDisplayString(game.away.team_short_name), 1),
                                _createElementVNode("span", _hoisted_15, _toDisplayString(game.away.division), 1)
                              ])
                            ])
                          ])
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            (_ctx.season.groups?.length > 0)
              ? (_openBlock(), _createElementBlock("table", _hoisted_18, [
                  _createElementVNode("tbody", _hoisted_19, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.season.groups, (group) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: group.id,
                        class: "group-table-tr"
                      }, [
                        _createElementVNode("th", _hoisted_20, _toDisplayString(group.name), 1),
                        _createElementVNode("td", _hoisted_21, [
                          _createVNode(_component_router_link, {
                            to: {
                        name: 'seasonGame',
                        params: { topic_id: _ctx.$route.params.topic_id, season_id: _ctx.$route.params.season_id },
                        query: { custom: group.id} },
                            class: "allLink"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_22
                            ]),
                            _: 2
                          }, 1032, ["to"])
                        ]),
                        _createElementVNode("td", _hoisted_23, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.groups, (childGroup) => {
                            return (_openBlock(), _createBlock(_component_router_link, {
                              key: childGroup.id,
                              to: {
                          name: 'seasonGame',
                          params: { topic_id: _ctx.$route.params.topic_id, season_id: _ctx.$route.params.season_id },
                          query: { custom: group.id, group: childGroup.id } },
                              class: "link"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(childGroup.name), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"]))
                          }), 128))
                        ])
                      ]))
                    }), 128))
                  ])
                ]))
              : (!_ctx.season.isLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, _hoisted_26))
                : _createCommentVNode("", true),
            _withDirectives(_createElementVNode("div", _hoisted_27, null, 512), [
              [_vShow, _ctx.season.isLoading]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _hoisted_30,
            (_ctx.season.entries?.length > 0)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_31, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.season.entries, (entry) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: entry.id,
                      class: "item"
                    }, [
                      _createVNode(_component_router_link, {
                        to: {
                      name: 'seasonEntryDetail',
                      params: { topic_id: _ctx.$route.params.topic_id, season_id: _ctx.$route.params.season_id, team_id: parseInt(entry.id) } },
                        class: "link"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(entry.team_name) + " ", 1),
                          _createElementVNode("span", _hoisted_32, _toDisplayString(entry.division), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ]))
                  }), 128))
                ]))
              : (!_ctx.season.isLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_33, _hoisted_35))
                : _createCommentVNode("", true),
            _withDirectives(_createElementVNode("div", _hoisted_36, null, 512), [
              [_vShow, _ctx.season.isLoading]
            ])
          ])
        ])
      ])
    ])
  ]))
}